// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__wP_GU"};